export default __webpack_public_path__ + "static/media/case3.50f9d6df.jpg";